import type { ApplePayJS } from '../../../../../types/apple-pay'

/**
 * Serializes an Apple Pay payment request to ensure it can be cloned by postMessage.
 * This is necessary for the Apple Pay SDK in third-party browsers (Chrome, Edge, Firefox),
 * which uses postMessage internally and cannot clone non-serializable values.
 *
 * The structured clone algorithm used by postMessage cannot handle:
 * - Functions
 * - Class instances (unless they're built-in types)
 * - Symbols
 * - DOM nodes
 * - Certain built-in objects
 *
 * @param request - The Apple Pay payment request to serialize
 * @returns A plain object that can be safely passed through postMessage
 */
export function serializePaymentRequest(
  request: ApplePayJS.ApplePayPaymentRequest,
): ApplePayJS.ApplePayPaymentRequest {
  // Use JSON.parse(JSON.stringify()) to create a deep clone with only serializable values
  // This removes any functions, symbols, or non-cloneable objects
  return JSON.parse(JSON.stringify(request))
}
